import React from 'react';
import './Header.css';
import { getUserDetailsCookie, isLoggedIn} from "../../Api/Utils/apiUtils";
import IdentityApi from "../../Api/IdentityApi";
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import { setUserDeActiveOnChat } from '../../Api/Utils/chatUtils';
import { Link, useHistory } from 'react-router-dom';
import CustomNavigation from '../CustomNavigation/CustomNavigation';

const Header = () => {
    const isUserLoggedIn = isLoggedIn();
    const user = getUserDetailsCookie();
    const { userType } = user;
    const showMembers  = !userType || userType === 'buyer';
    const showBusiness  = !userType || userType === 'supplier';
    const history = useHistory()

    const logoutUser = () => {
        setUserDeActiveOnChat(user.id)
        IdentityApi.logout();
        history.push('/login')
    }
    return (
        <>
            <Navbar expand="lg" variant="dark" className="header-top" sticky="top">
                <Container>
                    <Navbar.Brand href="https://elitepartyz.com/">
                        <img src="/img/logo.webp" width="65" height="65"
                            className="d-inline-block align-top"
                            alt="Elite partyz"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <a href="https://elitepartyz.com/" rel='canonical' className='nav-link'>Home</a>
                            { showMembers && <a href rel='canonical' className='nav-link' to="https://elitepartyz.com/members">Members</a>}
                            { showBusiness && <a href rel='canonical' className='nav-link' to="https://elitepartyz.com/business">Business</a> }
                            <NavDropdown title="Tutorials" id="tutorials-nav-dropdown">
                                { showMembers &&
                                    <a href className='nav-link' rel='canonical' to="https://elitepartyz.com/member-app-tutorials">Members Tutorials</a>
                                }
                                { showBusiness &&
                                    <a href className='nav-link' rel='canonical' to="https://elitepartyz.com/business-app-tutorials">Business Tutorials</a>
                                }
                            </NavDropdown>
                            { isUserLoggedIn &&
                                <NavDropdown title="Account" id="account-nav-dropdown">
                                    <Link className='nav-link 'to="/profile">Manage profile</Link>
                                    {showMembers &&
                                    <>
                                        <Link className='nav-link 'to="/add-event">Add event</Link>
                                        <Link className='nav-link 'to="/manage-events">Manage events</Link>
                                        <Link className='nav-link 'to="/manage-payments">Manage payments</Link>
                                        <Link className='nav-link 'to="/suppliers">Suppliers</Link>
                                        <Link className='nav-link 'to="/favourite-suppliers">Favourite
                                            suppliers</Link>
                                    </>
                                    }
                                    {showBusiness &&
                                    <>
                                        <Link className='nav-link 'to="/business-profile">Business profile</Link>
                                        <Link className='nav-link 'to="/add-product">Add product</Link>
                                        <Link className='nav-link 'to="/manage-products">Manage products</Link>
                                        <Link className='nav-link 'to="/manage-business">Manage business</Link>
                                        <Link className='nav-link 'to="/manage-orders">Manage orders</Link>
                                        <Link className='nav-link 'to="/manage-payment-method">Manage payments</Link>
                                    </>
                                    }
                                    <Link className='nav-link 'to="/change-password">Change password</Link>
                                </NavDropdown>
                            }
                            <CustomNavigation />
                        </Nav>
                        <Nav className="support-nav-group">
                            { isUserLoggedIn && <Link className='nav-link' to="/messages" >Messages</Link> }
                            <a href className='nav-link' rel='canonical' to="https://elitepartyz.com/support">Support</a>
                            <a href className='nav-link' rel='canonical' to="https://elitepartyz.com/blog">Blog</a>
                            { !isUserLoggedIn && <Link className='nav-link' rel='canonical' to="/login">Login</Link> }
                            { isUserLoggedIn &&
                                <Nav.Item >
                                    <div onClick={logoutUser} className="nav-link">Logout</div>
                                </Nav.Item>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {/* <NotificationBanner icon={faInfoCircle}>
                The website is still being built. You may not be able to access all the features.
            </NotificationBanner> */}
        </>
    )
}

export default Header
